import React from 'react'

const HiddenInput = (props: { id: string, value: string }) => {

   return (
      <input type="hidden" name={props.id} id={props.id} value={props.value} />
   )
}

export default HiddenInput